var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),_c('div',{attrs:{"id":"fb-root"}}),_vm._v(" "),_c('div',{staticClass:"fb-customerchat",attrs:{"attribution":"setup_tool","page_id":"360179007717640","theme_color":"#BAA069","logged_in_greeting":"搜飾盒是全新珠寶換戴平台，請問有什麼可以幫到你？","logged_out_greeting":"搜飾盒是全新珠寶換戴平台，請問有什麼可以幫到你？"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8b83af8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 